<div [formGroup]="form"> 
    <div class="mt-top-2">
      <mat-form-field>
        <mat-label>Password</mat-label>
        <input matInput formControlName="password" [type]="hide ? 'password' : 'text'"
          autocomplete="new-password">
        <button mat-icon-button matSuffix (click)="hide = !hide" [attr.aria-label]="'Hide password'"
          [attr.aria-pressed]="hide">
          <mat-icon>{{hide ? 'visibility_off' : 'visibility'}}</mat-icon>
        </button>
        <ng-container *ngIf="submitted && passwordControl['password'].errors">
          <mat-error *ngIf="passwordControl['password'].errors?.['required']">
              <em
               class="fas fa-exclamation-circle mr-2"></em>Password is required
          </mat-error>
          <mat-error *ngIf="passwordControl['password'].errors?.['pattern']">
            <em
             class="fas fa-exclamation-circle mr-2"></em>Invalid password pattern
        </mat-error>
       </ng-container>
      </mat-form-field>
    </div>
    <div class="mt-top-2">
      <mat-form-field>
        <mat-label>Confirm Password</mat-label>
        <input matInput formControlName="confirmPassword" [type]="confirmHide ? 'password' : 'text'"
          autocomplete="new-password">
        <button mat-icon-button matSuffix (click)="confirmHide = !confirmHide" [attr.aria-label]="'Hide password'"
          [attr.aria-pressed]="confirmHide">
          <mat-icon>{{confirmHide ? 'visibility_off' : 'visibility'}}</mat-icon>
        </button>
        <ng-container *ngIf="submitted && passwordControl['confirmPassword'].errors">
          <mat-error *ngIf="passwordControl['confirmPassword'].errors?.['required']">
              <em
               class="fas fa-exclamation-circle mr-2"></em>Confirm Password is required
          </mat-error>
          <mat-error
          *ngIf="submitted && passwordControl['confirmPassword'].errors?.['mustMatch']">
          Passwords do not match
        </mat-error>
       </ng-container>
      </mat-form-field>
    </div>
  </div>
  